// extracted by mini-css-extract-plugin
export default {"wrapper":"Billing_wrapper__bC3di","tableContainer":"Billing_tableContainer__5hgPg","copyToExcelButton":"Billing_copyToExcelButton__UO-qL"};